module.exports = __webpack_public_path__ + "static/media/settings.90c8d4a4.svg";